import { gql } from "@apollo/client";

export const GET_PAST_WELLNESS_PLANS = gql`
    query GetPastWellnessPlans {
    getPastWellnessPlans {
        success
        messages
        pastWellnessPlans {
            animal_id
            active
            endDate
            wellnessPlanName
            planName
        }
    }
}`;
